module.exports = __webpack_public_path__ + "fonts/Inter-200-vietnamese33.5fc7f74.woff2";